import { createSlice } from "@reduxjs/toolkit";
import { addAreaAPI, batchDeleteAreaAPI, deleteAreaAPI, getAreaAPI, getAreaListAPI, updataAreaAPI } from "../../apis/area";
import { getUserInfo } from "../../utils/localStorage/userInfo";

const areaStore = createSlice({
  name: "area",
  initialState: {
    area: [],
    // 区域管理部分
    areaList:[],
    total:0,
    page:{
      page: 1,
      pageSize: 10,
    }
  },
  reducers: {
    setArea(state, action) {
      state.area = action.payload;
    },
    setAreaList(state, action) {
      state.areaList = action.payload;
    },
    setTotal(state,action){
      state.total=action.payload
    },
    setPage(state,action){
      state.page=action.payload;
    },
    addAreaItem(state, action) {
      state.areaList.push({...action.payload,createManagerName:getUserInfo().managerName});
      state.total=state.total+1
    },
    deleteAreaItem(state,action){
      state.areaList=state.areaList.filter((item)=>item.id!==action.payload)
      state.total=state.total-1
    },
    batchdeleteAreaItem(state, action) {
      state.areaList=state.areaList.filter((item) => !action.payload.includes(item.id));
      state.total=state.total-action.payload.length
    },
    updateAreaItem(state, action) {
      const index = state.areaList.findIndex((item) => item.id === action.payload.id);
      state.areaList[index] = {...state.areaList[index],...action.payload}
    },
  },
});

const { setArea,setAreaList,setTotal,setPage,addAreaItem,deleteAreaItem,batchdeleteAreaItem,updateAreaItem } = areaStore.actions;

const fetchArea = () => {
  return async (dispatch) => {
    // const res = await getAreaAPI();
    // dispatch(setArea(res.data.data));
    getAreaAPI().then((res)=>{
      dispatch(setArea(res.data.data));
    }).catch((err)=>{
      console.log(err.message)
    })
  };
};
const fetchAreaList=(page)=>{
  return async (dispatch)=>{
    // const res=await getAreaListAPI(page)
    getAreaListAPI(page).then((res)=>{
      dispatch(setAreaList(res.data.data.records))
      dispatch(setTotal(res.data.data.total))
    }).catch((err)=>{
      console.log(err.message)
    })

  }
}
const addArea=(item)=>{
  return async (dispatch)=>{
    const res=await addAreaAPI(item)
    if(res){
      dispatch(addAreaItem(res.data))
    }
  }
}
const deleteArea=(areaId)=>{
  console.log('删除的id',areaId)
  return async(dispatch)=>{
    const res=await deleteAreaAPI(areaId)
    if(res){
      dispatch(deleteAreaItem(areaId))
    }
  }
}
const batchDeleteArea=(areaId)=>{
  return async(dispatch)=>{
    const res=await batchDeleteAreaAPI(areaId)
    if(res){
      dispatch(batchdeleteAreaItem(areaId))
    }
  }
}
const updateArea=(item)=>{
  return async (dispatch)=>{
    const res=await updataAreaAPI(item)
    if(res){
      dispatch(updateAreaItem(item))
    }
  }
}
export {setPage}
export { fetchArea,fetchAreaList,addArea,deleteArea,batchDeleteArea,updateArea };

const areaReducer = areaStore.reducer;
export default areaReducer;
